import { render, staticRenderFns } from "./SifrantProizvodItem.vue?vue&type=template&id=09257bf1&"
import script from "./SifrantProizvodItem.vue?vue&type=script&lang=js&"
export * from "./SifrantProizvodItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports